import { render, staticRenderFns } from "./LawyerArea.vue?vue&type=template&id=237438a0&scoped=true&"
import script from "./LawyerArea.vue?vue&type=script&lang=js&"
export * from "./LawyerArea.vue?vue&type=script&lang=js&"
import style0 from "./LawyerArea.vue?vue&type=style&index=0&id=237438a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237438a0",
  null
  
)

export default component.exports